module.exports = __webpack_public_path__ + "img/unlock.f3824513.svg";